/*
 * @Description: 线上数据管理
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const classAdministrationRouter: Array<RouteRecordRaw> = [
    {
        path: '/classAdministration',
        component: Layout,
        redirect: '/classAdministration/campusData',
        children: [
            {
                path: 'campusData',
                component: () => import(/* webpackChunkName: "campusData" */ '@/views/classAdministration/campusData/index.vue'),
                name: 'campusData',
                meta: { title: '校区管理' },
            },
            {
                path: 'buildingData',
                component: () => import(/* webpackChunkName: "buildingData" */ '@/views/classAdministration/buildingData/index.vue'),
                name: 'buildingData',
                meta: { title: '楼栋管理' },
            },
            {
                path: 'classroomData',
                component: () => import(/* webpackChunkName: "classroomData" */ '@/views/classAdministration/classroomData/index.vue'),
                name: 'classroomData',
                meta: { title: '教室管理' },
            }
        ]
    }
]

export default classAdministrationRouter
